const dataTabs = {
    profile: [
        'firstname',
        'lastname',
        'patronymic',
        'gender',
        'email',
        'phone',
    ],
    contacts: ['country', 'city', 'address', 'postal_code'],
    passport: ['series_number', 'date_issue'],
    tfa: ['2fa_type', '2fa_verification_required', '2fa_available_types'],
    session: ['datetime', 'session_2fa_personaldata_until'],
}

const initUserDataState = {
    profile: {},
    contacts: {},
    passport: {},
    tfa: {},
    session: {},
    success: {
        userData: false,
        personalData: false,
    },
}

export function UserData(state = initUserDataState, action) {
    switch (action.type) {
        case 'ADD_USER_DATA':
            return addDataStructure(state, action.obj)
            break
        case 'TFA_SESSION_TIMEOUT':
            return tfaSessionTimeout(state, action.obj)
        case 'WRONG_TFA_CODE':
            return tfaWrongCode(state, action.obj)
        case 'CLEANING_USER_STATE':
            return cleaningUserState(state)
        default:
            return state
    }
}

function tfaSessionTimeout(state, obj) {
    return Object.assign({}, state, obj)
}

function tfaWrongCode(state, obj) {
    return Object.assign({}, state, obj)
}

function cleaningUserState(state) {
    return Object.assign({}, initUserDataState)
}

function addDataStructure(state, obj) {
    let fixedData = []
    for (let tab in dataTabs) {
        dataTabs[tab].forEach(item => {
            fixedData.push(item)
        })
    }

    for (let item in obj) {
        for (let tab in dataTabs) {
            dataTabs[tab].forEach(item => {
                if (obj.hasOwnProperty(item)) {
                    state = Object.assign({}, state, {
                        [tab]: {
                            ...state[tab],
                            [item]: obj[item],
                        },
                    })
                }
            })

            if (fixedData.indexOf(item) < 0) {
                state = Object.assign({}, state, {
                    [item]: obj[item],
                })
            }
        }
    }
    return dataValidation(state)
}

function dataValidation(state) {
    let descriptionObj = {}

    for (let item in state) {
        if (
            typeof state[item] === 'object' &&
            item !== 'session' &&
            item !== 'success'
        ) {
            descriptionObj[item] = addDataDescription(state, item, state[item])
        }
    }
    return Object.assign({}, state, descriptionObj)
}

function addDataDescription(state, item, obj) {
    let descriptionObj = {}

    for (let prop in obj) {
        if (
            prop !== '2fa_verification_required' &&
            prop !== '2fa_available_types'
        ) {
            descriptionObj[prop] = {
                key: prop === 'series_number' || prop === 'date_issue'
                        ? `passport-${prop}`
                        : prop,
                title: titleReplace(prop),
                value: valueReplace(prop, obj[prop]),
                options: optionsReplace(prop, ''),
                readOnly:
                    prop === 'email' || prop === '2fa_type' ? true : false,
            }
            descriptionObj[prop]['type'] = descriptionObj[prop]['options']
                ? 'select'
                : 'input'
        } else if (prop === '2fa_available_types') {
            descriptionObj[prop] = {
                key: prop,
                title: titleReplace(prop),
                value: valueReplace(prop, descriptionObj['2fa_type'].value),
                options: optionsReplace(prop, obj[prop]),
                readOnly:
                    prop === 'email' || prop === '2fa_type' ? true : false,
            }
            descriptionObj[prop]['type'] = descriptionObj[prop]['options']
                ? 'select'
                : 'input'
        } else {
            descriptionObj[prop] = obj[prop]
        }
    }
    return descriptionObj
}

function titleReplace(title) {
    let prevTitle = title.replace(/^2fa_/gi, '').replace(/_/gi, ' ')
    return prevTitle.slice(0, 1).toUpperCase() + prevTitle.slice(1)
}

function valueReplace(item, value) {
    if (item === 'gender' && !value) {
        return 'Unknown'
    } else if (item === 'phone' && value === null) {
        return ''
    } else if (item === 'date_issue' && value === null) {
        return ''
    } else if (item === '2fa_type') {
        return correctTFATypes(value)
    } else if (item === '2fa_available_types') {
        return correctTFATypes(value)
    } else {
        return value
    }
}

function optionsReplace(item, value) {
    if (item === 'gender') {
        return ['Unknown', 'Man', 'Woman']
    } else if (item === '2fa_available_types') {
        let correctAvailableTypes = []
        value.forEach(item => {
            if (item !== 'none') {
                let correctTFAType = correctTFATypes(item)
                correctAvailableTypes.push(correctTFAType)
            }
        })
        return correctAvailableTypes
    } else {
        return value
    }
}

function correctTFATypes(type) {
    switch (type) {
        case 'sms':
            return type.toUpperCase()
            break
        case 'ga':
            return 'Google authenticator'
            break
        default:
            return titleReplace(type)
            break
    }
}
